import { types, Instance } from 'mobx-state-tree';
// Persistence disabled - layout loaded fresh from user preferences

export const LayoutStore = types
  .model('LayoutStore', {
    sidebarWidth: types.optional(types.number, 240),
    projectPaneWidth: types.optional(types.number, 300),
    splitPanePosition: types.optional(types.number, 300),
    isSidebarCollapsed: types.optional(types.boolean, false),
    nodeSidebarWidth: types.optional(types.number, 480),
    isNodeSidebarOpen: types.optional(types.boolean, false),
    isProjectSidebarOpen: types.optional(types.boolean, true),
    projectSidebarWidth: types.optional(types.number, 240),
    isActivityFeedOpen: types.optional(types.boolean, false),
    activityFeedHeight: types.optional(types.number, 300),
    isDebugPanelVisible: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    setSidebarWidth(width: number) {
      if (width >= 60 && width <= 400) {
        self.sidebarWidth = width;
      }
    },
    setProjectPaneWidth(width: number) {
      // Allow project pane to be resized within reasonable limits
      if (width >= 200 && width <= 1000) {
        self.projectPaneWidth = width;
      }
    },
    setSplitPanePosition(position: number) {
      if (position >= 200 && position <= 500) {
        self.splitPanePosition = position;
      }
    },
    /**
     * Load sidebar collapsed state from preferences
     * Called during app initialization
     */
    loadSidebarStateFromPreferences(collapsed: boolean) {
      self.isSidebarCollapsed = collapsed;
    },
    toggleSidebar() {
      self.isSidebarCollapsed = !self.isSidebarCollapsed;
      // Note: Caller should also update preferences store
    },
    setSidebarCollapsed(collapsed: boolean) {
      self.isSidebarCollapsed = collapsed;
      // Note: Caller should also update preferences store
    },
    setNodeSidebarWidth(width: number) {
      if (width >= 0 && width <= 600) {
        self.nodeSidebarWidth = width;
      }
    },
    openNodeSidebar() {
      self.isNodeSidebarOpen = true;
    },
    closeNodeSidebar() {
      self.isNodeSidebarOpen = false;
    },
    toggleNodeSidebar() {
      self.isNodeSidebarOpen = !self.isNodeSidebarOpen;
    },
    toggleDebugPanel() {
      self.isDebugPanelVisible = !self.isDebugPanelVisible;
    },
    setDebugPanelVisible(visible: boolean) {
      self.isDebugPanelVisible = visible;
    }
  }));

// REMOVED: No longer creating a singleton instance here. AppStore is responsible.
// export const layoutStore = LayoutStore.create();

// DISABLED persistence to prevent MST reference conflicts
// if (typeof window !== 'undefined') {
//   // // persist('layout', layoutStore, {
//     storage: localStorage,
//     jsonify: true,
//   }).then(() => {
//     console.log('Layout preferences restored from localStorage');
//   });
// }

// REMOVED: Components should get the layout store from useAppStore()
// export const useLayout = () => layoutStore;

// For TypeScript
export interface ILayoutStore extends Instance<typeof LayoutStore> {} 